import keyMirror from 'keymirror'
import i18n from '@/utils/i18n'

export const E_CIRCULAR_TYPES = keyMirror({
  TENANT: null,
  VENDOR: null,
  TENANCY: null,
})

/** Stored on e_circulars.userType JSON array: TR codes align with server E_CIRCULAR_CONTACT_TYPES_MAP; marketing uses stable codes (same pattern as eCir / fire). */
export const E_CIRCULAR_USER_TYPE_CODES = {
  isCircular: 'eCir',
  isFireMarshal: 'fire',
  marketing: 'marketing',
  CRM: 'crm',
  PR: 'pr',
  shop: 'shop',
}

/** Role option keys under tenancy.roleTypeOptions — same order as AddRecipients marketingOptions */
export const E_CIRCULAR_MARKETING_ROLE_KEYS = ['marketing', 'CRM', 'PR', 'shop']

export const E_CIRCULAR_MARKETING_USER_TYPE_CODES = E_CIRCULAR_MARKETING_ROLE_KEYS.map(
  (k) => E_CIRCULAR_USER_TYPE_CODES[k],
)

/**
 * Legacy: map translated MultiSelect label to userType code (CompanyContact.roleType stores i18n strings).
 * Prefer storing codes in marketingParams.marketingTypes; this remains for one-off migration from old sessions.
 */
export function marketingRoleLabelToUserTypeCode (roleLabel) {
  if (!roleLabel) return null
  for (const key of E_CIRCULAR_MARKETING_ROLE_KEYS) {
    if (i18n.t(`tenancy.roleTypeOptions.${key}`) === roleLabel) {
      return E_CIRCULAR_USER_TYPE_CODES[key]
    }
  }
  return null
}

/** Normalize marketing multiselect values to stable userType / API codes (migrates legacy label strings). */
export function normalizeMarketingTypeParamsToCodes (values) {
  if (!values || !values.length) return []
  return values
    .map((item) => {
      if (E_CIRCULAR_MARKETING_USER_TYPE_CODES.includes(item)) return item
      return marketingRoleLabelToUserTypeCode(item)
    })
    .filter(Boolean)
}

export function marketingUserTypeCodeToLabel (code) {
  if (!code) return null
  const key = E_CIRCULAR_MARKETING_ROLE_KEYS.find((k) => E_CIRCULAR_USER_TYPE_CODES[k] === code)
  return key ? i18n.t(`tenancy.roleTypeOptions.${key}`) : null
}

export const E_CIRCULAR_OPTIONS = [{
  name: i18n.t('eCircular.options.tenant'),
  value: E_CIRCULAR_TYPES.TENANT,
}, {
  name: i18n.t('eCircular.options.vendor'),
  value: E_CIRCULAR_TYPES.VENDOR,
}]

export const E_CIRCULAR_STATUS = keyMirror({
  DRAFT: null,
  SUBMITTED: null,
  SCHEDULED: null,
  SENDING: null,
  SENT: null,
  RESENT: null,
  CANCELLED: null,
})

export const E_CIRCULAR_EDITABLE_STATUS = keyMirror({
  DRAFT: null,
  SUBMITTED: null,
})

export const E_CIRCULAR_WORKING_STATUS = keyMirror({
  DRAFT: null,
  SUBMITTED: null,
  SCHEDULED: null,
})

export const EMAIL_SENT_RESULTS = {
  DRAFT: 'DRAFT',
  PENDING: 'PENDING',
  SENT: 'SENT',
  FAILED: 'FAILED',
}

export const RECIPIENT_TYPES = {
  TO: 'TO',
  CC: 'CC',
  BCC: 'BCC',
}

export const PREVIEW_TYPES = {
  SEND: 'SEND',
  RESEND: 'RESEND',
}

export const SEND_OPTIONS = {
  SEND_NOW: 'SEND_NOW',
  SEND_AS_SCHEDULE: 'SEND_AS_SCHEDULE',
}
